/**
 * Used on the CTA cards in the vacancy pages.
 * Sticky translateY only at desktop viewport (matches SCSS `media-desktop`).
 */
const desktopMinWidthPixels = 1024;

export const stickyCta = () => {
    const ctaContainer = document.getElementById("cta-container");
    if (!ctaContainer) return;

    const stickyCtaElement = ctaContainer.getElementsByClassName("card-cta")[0];
    if (!(stickyCtaElement instanceof HTMLElement)) return;

    let isDesktopViewport = window.innerWidth >= desktopMinWidthPixels;
    let previousIsDesktopViewport = isDesktopViewport;

    // CTA and values for desktop layout and behavior
    let containerBoudingClient = ctaContainer.getBoundingClientRect();
    let ctaBoundingClient = stickyCtaElement.getBoundingClientRect();
    let offset = containerBoudingClient.bottom - ctaBoundingClient.bottom;

    const handleScroll = () => {
        const scrollY = window.scrollY;
        if (isDesktopViewport) {
            stickyCtaElement.style.transform = `translateY(${Math.min(scrollY, offset)}px)`;
        } else {
            stickyCtaElement.style.removeProperty("transform");
        }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    const handleResize = () => {
        containerBoudingClient = ctaContainer.getBoundingClientRect();
        ctaBoundingClient = stickyCtaElement.getBoundingClientRect();

        const regex = /\(([^)]+)\)/;
        const transformValue = regex.exec(stickyCtaElement.style.transform);
        if (transformValue !== null) {
            offset =
                containerBoudingClient.bottom -
                ctaBoundingClient.bottom +
                parseFloat(transformValue[1].replace("px", ""));
        } else {
            offset = containerBoudingClient.bottom - ctaBoundingClient.bottom;
        }

        isDesktopViewport = window.innerWidth >= desktopMinWidthPixels;

        if (!isDesktopViewport && previousIsDesktopViewport) {
            previousIsDesktopViewport = false;
            stickyCtaElement.style.removeProperty("transform");
        } else if (isDesktopViewport && !previousIsDesktopViewport) {
            previousIsDesktopViewport = true;
        }

        handleScroll();
    };

    window.addEventListener("resize", handleResize);
};
